import {h, Component} from 'preact';
import Util from '../../services/util';

export default class ChangePasswordIntro extends Component {
    constructor() {
        super();
    }

    nextStep = () => {
        this.props.setStep('updateOldPassword');
    };

    renderDeviceIcon = (uaFamily) => {
        if (uaFamily.indexOf('windows') > -1 || uaFamily === '') {
            return <img src='img/settings_icon_pc.svg' alt={'pc'} />;
        }
        if (uaFamily.indexOf('mac') > -1) {
            return <img src='img/settings_icon_mac.svg' alt={'mac'} />;
        }
        if (uaFamily.indexOf('ios') > -1) {
            return <img src='img/settings_icon_iphone.svg' alt={'ios'} />;
        }
        if (uaFamily.indexOf('android') > -1) {
            return <img src='img/settings_icon_android.svg' alt={'android'} />;
        }
    };

    render({connectedDevices, connectedApps, userCulture}, {}) {
        return(
            <div className='form change-password-intro'>
                <h2>Make sure you don’t get locked out</h2>
                <p>If your devices repeatedly try to sign in with your old password they will trigger an account lock-down.<br/>
                   You’ll need to change your password on these devices to keep working:</p>
                <h5>Connected devices</h5>
                {!!connectedDevices.length ? (
                    <div className='d-flex flex-wrap connected-items'>
                        {connectedDevices.map((device) => (
                            <div className={`flex-shrink-0 connected-item ${device.isLocal ? 'local' : ''}`} id={device.id}>
                                <div className='item-icon d-flex align-items-center'>
                                    {this.renderDeviceIcon(device.uaFamily.toLowerCase())}
                                </div>
                                <p className='item-name'>{Util.limitNameLength(device.deviceName, 45, 6)}</p>
                                <p className='item-location'>{Util.locationCityStateCountry(device.location, device.ip)}</p>
                                {device.remoteWipeStatus.toLowerCase() === 'none' ? (
                                    <p className='item-timeStamp'>{Util.timeAgo(device.timeStamp)}</p>
                                ) : (
                                    <p className='item-remoteWipeStatus'>Remote Wipe Status: {device.remoteWipeStatus}</p>
                                )}
                                {device.isLocal ? (<div className='item-current-status'>Nearby</div>) : null}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className='empty-message'>
                        <img src='img/empty-devices.png' srcSet='img/empty-devices@2x.png 2x, img/empty-devices@2x.png 3x' alt='no connected devices'/>
                        No connected devices
                    </p>
                )}
                <h5>Connected apps</h5>
                {!!connectedApps.length ? (
                    <div className='d-flex flex-wrap connected-items'>
                        {connectedApps.map((app) => (
                            <div className={`flex-shrink-0 connected-item ${app.isLocal ? 'local' : ''}`} id={app.id}>
                                <div className='item-icon d-flex align-items-center'>
                                    <img src='img/settings_icon_browser.svg' alt={'browser'} />
                                </div>
                                <p className='item-name'>{Util.limitNameLength(app.appName, 45, 6)}</p>
                                <p className='item-location'>{Util.locationCityStateCountry(app.location, app.ip)}</p>
                                <p className='item-timeStamp'>{Util.timeAgo(app.timeStamp)}</p>
                                {app.isLocal ? (<div className='item-current-status'>Nearby</div>) : null}
                            </div>
                        ))}
                    </div>
                ) : (
                    <p className='empty-message'>
                        <img src='img/empty-apps.png' srcSet='img/empty-apps@2x.png 2x, img/empty-apps@2x.png 3x' alt='no connected apps'/>
                        No connected apps
                    </p>
                )}
                <div className='bottom-buttons clearfix'>
                    <a className='button button-prime pull-right' onClick={this.nextStep}>Got it</a>
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/change-password/change-password-intro.js